<template>
	<div class="selectView flexBox flex-r h100pct">
		<div class="flex-1 border-r flexBox flex-c searchPanelR">
			<div class="inputwrap bdSub-bottom w90pct ml2x flexBox flex-r">
				<input v-model="name" @keyup.enter="serch" ref="input" class="inputcust mb08x" :placeholder="getLanguageStr('manage296', '输入成员姓名')" />
				<i class="fa fa-search w4x fs14x mt05x" ref="fasearch" @click="serch"></i>
			</div>
			<div class="flex-1 bdSub-bottom posR pt2x pl1x pr1x">
				<div
					v-if="showSearch"
					scroll
					v-clickoutside="handleClose"
					class="panel bgPanel h80pct posA w90pct mt1x flexBox flex-c pd1x searchPanel"
					style="position: absolute !important; top: 0; left: 0; z-index: 10; margin-left: 3%; box-shadow: 0 0.2em 0.6em rgba(0, 0, 0, 0.2)"
				>
					<Loading v-show="searchPanelShow" />
					<div class="h26x" v-show="(!searchPanelList || searchPanelList.length === 0) && !searchPanelShow">
						<NoResult />
					</div>
					<div class="min-h20x" style="overflow: hidden" v-show="searchPanelList && searchPanelList.length > 0">
						<div
							class="flexBox flex-r bdSub-bottom curP hoverFlex pt1x pb1x bdSub-bottom"
							@click.stop="selectMember(item)"
							v-for="item in searchPanelList"
							:key="item.orgUserDto.userInfo.id"
						>
							<div class="picHead w5x h4x flexBox flex-just flex-aligh" :class="{ disable: tagMap.length >= limit || isChecked(item.orgUserDto.userInfo.id) }">
								<div class="w4x h4x">
									<Logo LogoType="person" customClass="w4x h4x" :Logourl="item.orgUserDto.userInfo.photo" />
								</div>
							</div>
							<div class="flexBox flex-just flex-1 flex-c pl2x">
								<div class="title fsLv2">{{ item.orgUserDto.userInfo.name }}</div>
								<div class="cSub fsLv1">{{ item.orgUserDto.groupName }}</div>
							</div>
						</div>
					</div>
				</div>
				<transition-group
					name=""
					class="tag-wrap"
					v-on:leave="
						(el) => {
							transitionAction(el, 'hide-x');
						}
					"
					:duration="500"
				>
					<TagBox v-for="(tag, key) in tagMap" :key="'my-name' + key" class="show" :val="tag.name" @Remove="Remove(tag.id)"></TagBox>
				</transition-group>
			</div>
			<div class="bt toolBar h8x">
				<button class="subBtn" :title="getLanguageStr('cmd85', '取消')" @click.stop="hide('cancel')" type="button">
					{{ getLanguageStr("cmd85", "取消") }}
				</button>
				<button class="functionBtn" v-if="limit < 1000000" @click="ok" type="button">
					{{ getLanguageStr("user9", "确定") + "(" + tagMap.length + "/" + limit + ")" }}
				</button>
				<button class="functionBtn" v-else @click="ok" type="button">{{ getLanguageStr("user9", "确定") }}</button>
			</div>
		</div>
		<div class="flex-1 pl1x pr2x selectpanel fsLv2 flexBox">
			<div class="setep1 flexBox flex-c w100pct" v-show="bannerStructure.length === 0 && bannerRole.length === 0">
				<div class="bdSub-bottom pd1x pt1x curP flexBox flex-r" @click="toStructure">
					<div class="flex-1">{{ getLanguageStr("all48", "按内部组织架构选择") }}</div>
				</div>
				<div class="bdSub-bottom pd1x pt1x curP flexBox flex-r" @click="toRole">
					<div class="flex-1">{{ getLanguageStr("all49", "按角色选择") }}</div>
				</div>
			</div>

			<div class="setep2-orgnize flexBox flex-c flex-1" v-show="bannerStructure.length > 0">
				<div class="head-setep flexBox flex-r bdSub-bottom pb1x">
					<div class="w4x curP" @click="setUp">
						<Icon name="more" class="w2x h2x romate fSub" />
					</div>
					<div class="">
						<div>{{ getLanguageStr("all48", "按内部组织架构选择") }}</div>
						<div class="cSub fsLv1">
							{{
								bannerStructure.length > 0 &&
								bannerStructure
									.map((item) => {
										return mapStructure[item].name;
									})
									.toString()
									.replace(/,/g, "/")
							}}
						</div>
					</div>
				</div>
				<div class="h30x" scroll>
					<div class="min-h30x flexBox flex-c">
						<div class="bdSub-bottom pt105x pb105x flexBox flex-r pl3x curP" v-for="item in currentStructure" :key="item.id" @click="setepNext(item)">
							<div class="flex-1">{{ item.name }}({{ item.userCount }})</div>
							<div class="w6x"><Icon name="group" class="w2x h2x fIcon" /></div>
						</div>
						<div class="flex-1">
							<Loading v-show="Structureloading" />
							<div class="h26x" v-show="!structurePerson || structurePerson.length === 0">
								<NoResult />
							</div>
							<label
								class="bdSub-bottom dpb pt05x pb05x flexBox flex-r pl3x curP pt105x pb105x"
								:class="{ disable: tagMap.length === limit && !item.selected ? true : false }"
								v-for="item in structurePerson"
								:key="item.orgUserDto.userInfo.id"
							>
								<div class="flex-1 flexBox">
									<Checkbox :textStyle="'textCut'" :checkObj="item" v-model="item.selected" :triggerClick="false" class="mr05x" @Click="selectModule">
										<div class="w6x h4x pl1x pr1x dpB"><Logo LogoType="person" customClass="w4x h4x" :Logourl="item.orgUserDto.userInfo.photo" /></div>
										<span class="w55x">{{ item.orgUserDto.userInfo.name }}</span></Checkbox
									>
								</div>
							</label>
						</div>
					</div>
				</div>
			</div>

			<div class="setep2-role flexBox flex-c flex-1" v-show="bannerRole.length > 0">
				<div class="head-setep flexBox flex-r bdSub-bottom pb1x">
					<div class="w4x curP" @click="setUpRole">
						<Icon name="more" class="w2x h2x romate fSub" />
					</div>
					<div class="">
						<div>{{ getLanguageStr("all49", "按角色选择") }}</div>
						<div class="cSub fsLv1">
							{{
								bannerRole.length > 1
									? getTypeText(mapRole[bannerRole[1]].roleId, "roleType")
										? getTypeText(mapRole[bannerRole[1]].roleId, "roleType")
										: mapRole[bannerRole[1]].roleName
									: ""
							}}
						</div>
					</div>
				</div>
				<div class="h30x" scroll>
					<div class="min-h30x flexBox flex-c">
						<div v-show="bannerRole.length <= 1">
							<div class="bdSub-bottom pt105x pb105x flexBox flex-r pl3x curP" v-for="item in roleList" :key="item.roleId" @click="setepNextRole(item)">
								<div class="flex-1">{{ getTypeText(item.roleId, "roleType") ? getTypeText(item.roleId, "roleType") : item.roleName }}</div>
								<div class="w6x"><Icon name="group" class="w2x h2x fIcon" /></div>
							</div>
						</div>
						<div class="flex-1" v-show="bannerRole.length > 1">
							<Loading v-show="Roleloading" />
							<div class="h26x" v-show="!structurePerson || structurePerson.length === 0">
								<NoResult />
							</div>
							<label
								class="bdSub-bottom pt05x pb05x flexBox flex-r pl3x curP pt105x pb105x"
								:class="{ disable: tagMap.length === limit && !item.selected ? true : false }"
								v-for="item in structurePerson"
								:key="item.roleId"
							>
								<div class="flex-1 flexBox">
									<Checkbox :textStyle="' textCut'" v-model="item.selected" :checkObj="item" :triggerClick="false" class="mr05x" @Click="selectModule"
										><div class="w6x h4x pl1x pr1x dpB">
											<Logo LogoType="person" customClass="w4x h4x" :Logourl="item.orgUserDto.userInfo.photo" />
										</div>
										<span class="w55x">{{ item.orgUserDto.userInfo.name }}</span>
									</Checkbox>
								</div>
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import * as lib from "@/util/lib";
import { mapGetters, mapActions } from "vuex";
import { getLanguageStr } from "@/util/language";
import * as groupMemberApi from "@/api/manage/groupMember";
const clickoutside = {
	// 初始化指令
	bind(el, binding, vnode) {
		function documentHandler(e) {
			// 这里判断点击的元素是否是本身，是本身，则返回
			if (el.contains(e.target)) {
				return false;
			}
			// 判断指令中是否绑定了函数
			if (binding.expression) {
				// 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
				binding.value(e);
			}
		}
		// 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
		el.__vueClickOutside__ = documentHandler;
		document.addEventListener("click", documentHandler);
	},
	update() {},
	unbind(el, binding) {
		// 解除事件监听
		document.removeEventListener("click", el.__vueClickOutside__);
		delete el.__vueClickOutside__;
	},
};
export default {
	name: "selectMember",
	directives: { clickoutside },
	data() {
		return {
			name: "",
			firstId: "", // 首组的id
			structure: "", // 组织架构
			currentStructure: [], // 可显示的组织架构
			mapStructure: {}, // 组织架构的MAP版本
			bannerStructure: [], // 当前组织架构层级 此后每次点击进行push操作 返回执行pop
			structurePerson: [], // 当前组织架构下的人员
			Structureloading: false, // 组织机构的loading
			roleList: [], // 角色列表
			bannerRole: [], // 当前角色架构层级
			Roleloading: false, // 角色层loading
			mapRole: {}, // 角色数据架构map版本
			tagMap: [], // 已经选中的
			showSearch: false, // 搜索框内容的显示
			searchPanelList: [], // 搜索面板的人员列表
			searchPanelShow: false,
			canBeClick: true, // 控制点击事件在流程结束后可触发
		};
	},
	components: {},
	computed: {
		...mapGetters({
			userInfo: "user/userInfo",
			groupStructure: "groupMember/groupStructure",
		}),
	},
	watch: {
		showSearch(v) {
			if (v) {
				setTimeout(() => {
					lib.setScroll($(this.$el).find(".searchPanelR [scroll]"));
				}, 500);
			}
		},
	},
	props: {
		limit: {
			type: Number,
			default: 1000000,
		},
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		transitionAction: lib.transitionAction,
		...mapActions({
			GetRoleList: "roleFunc/GetRoleList",
		}),
		// 重置到初始页面
		reset() {
			this.name = "";
			this.bannerStructure = [];
			this.bannerRole = [];
		},
		// 判断当前人员是否选过
		isChecked(id) {
			let ischeck = false;
			this.tagMap.map((item) => {
				if (item.id === id) ischeck = true;
			});
			return ischeck;
		},

		// 设置选中的值
		setTagmap(data) {
			this.tagMap = data.slice(0);
		},
		hide() {
			this.$emit("Hide");
		},
		// 获取数据时判断checkBox的选中状况
		checkTheStatus(data) {
			if (!data) return;
			let idArr = this.tagMap.map((item) => {
				return item.id;
			});
			data.map((item) => {
				if (idArr.includes(item.orgUserDto.userInfo.id)) item.selected = true;
				else item.selected = false;
			});
		},
		// 公共的checkBox选择人员
		selectModule() {
			let [isSlect, type, obj] = Array.prototype.slice.apply(arguments);
			if (isSlect) {
				this.tagMap.push({ name: obj.orgUserDto.userInfo.name, id: obj.orgUserDto.userInfo.id, item: obj });
			} else {
				this.Remove(obj.orgUserDto.userInfo.id);
			}
		},
		// 模糊查询框and选择成员
		selectMember(item) {
			if (this.isChecked(item.orgUserDto.userInfo.id)) return;
			if (this.tagMap.length === this.limit) return;
			this.showSearch = false;
			// nextOk 出现重复的tag直接跳过
			let nextOk = true;
			for (let indexItem in this.tagMap) {
				if (this.tagMap[indexItem].id === item.orgUserDto.userInfo.id) {
					nextOk = false;
					break;
				}
			}
			if (!nextOk) return "";
			this.tagMap.push({ name: item.orgUserDto.userInfo.name, id: item.orgUserDto.userInfo.id, item });
			this.checkTheStatus(this.structurePerson);
		},
		// 搜索框筛选获取人员列表
		async searchRoleList() {
			this.searchPanelList = [];
			this.searchPanelShow = true;
			let filter = {
				page: 1,
				size: 100,
				"order.direction": "DESC",
				"order.property": "id",
				selectGroupId: this.firstId,
				name: this.name,
			};
			let result = await groupMemberApi.getOrgUserList(filter);
			this.searchPanelShow = false;
			this.searchPanelList = result.data;
		},
		handleClose(e) {
			if (e.target.contains(this.$refs.input) || e.target.contains(this.$refs.fasearch)) return "";
			this.showSearch = false;
			this.searchPanelList = [];
		},
		// 搜索人员
		serch() {
			if (!this.name) return "";
			this.showSearch = true;
			this.searchRoleList();
		},
		// remove选中选中的人员
		Remove(data) {
			this.tagMap = this.tagMap.filter((item) => {
				if (item.id !== data) return item;
			});
			this.checkTheStatus(this.structurePerson);
		},
		// 角色返回上级
		setUpRole() {
			this.bannerRole.pop();
		},
		// 点击角色
		async setepNextRole(item) {
			this.structurePerson = [];
			this.Roleloading = true;
			this.bannerRole.push(item.roleId);
			let filter = {
				page: 1,
				size: 1000,
				"order.direction": "DESC",
				"order.property": "id",
				selectGroupId: this.firstId,
				roleId: item.roleId,
			};
			let result = await groupMemberApi.getOrgUserList(filter);
			this.checkTheStatus(result.data);
			this.structurePerson = result.data;
			this.Roleloading = false;
		},
		// 前往角色分组
		toRole() {
			if (!this.canBeClick) return;
			this.canBeClick = false;
			let filter = {
				page: 1,
				size: 1000,
			};
			this.Roleloading = true;
			this.GetRoleList(filter).then((res) => {
				this.canBeClick = true;
				this.bannerRole = [0];
				this.roleList = res.roleList;
				this.mapRole = {};
				for (let i in this.roleList) {
					this.roleList[i].showName = this.getTypeText(this.roleList[i], "roleType")
						? this.getTypeText(this.roleList[i], "roleType")
						: this.roleList[i].roleName;
					this.mapRole[this.roleList[i].roleId] = this.roleList[i];
				}
				this.$nextTick(() => {
					this.canBeClick = true;
					lib.setScroll($(this.$el).find(".setep2-role [scroll]"));
					this.Roleloading = false;
				});
			});
		},
		// 点击进入组织架构
		toStructure() {
			if (!this.canBeClick) return;
			this.canBeClick = false;
			this.apiFunction();
		},
		// 返回上一级组织架构
		setUp() {
			this.bannerStructure.pop();
			if (this.bannerStructure.length === 0) return;
			this.getChildGroup(this.bannerStructure[this.bannerStructure.length - 1]);
			this.getGroupPerson();
		},
		// 点击子组 进入下一层及
		setepNext(data) {
			this.getChildGroup(data.id);
			this.bannerStructure.push(data.id);
			this.getGroupPerson();
		},
		// 获取当前组织架构下的人员
		async getGroupPerson() {
			this.structurePerson = [];
			this.Structureloading = true;
			let filter = {
				page: 1,
				size: 1000,
				"order.direction": "DESC",
				"order.property": "id",
				selectGroupId: this.bannerStructure[this.bannerStructure.length - 1],
			};
			let result = await groupMemberApi.getOrgUserList(filter);
			this.checkTheStatus(result.data);
			this.Structureloading = false;
			this.structurePerson = result.data;
			this.$nextTick(() => {
				lib.setScroll($(this.$el).find(".setep2-orgnize [scroll]"));
			});
		},
		// 获取当前组的子组
		getChildGroup(id) {
			if (!id) {
				this.currentStructure = this.structure.filter((item) => {
					if (item.parentId == this.firstId) return item;
				});
			} else {
				this.currentStructure = this.structure.filter((item) => {
					if (item.parentId == id) return item;
				});
			}
		},
		// 第一次函数执行获取基础数据
		async apiFunction() {
			await new Promise((resolve) => {
				this.getFirstId()
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						console.log(error);
						this.canBeClick = true;
					});
			});
			this.bannerStructure = [this.firstId];
			this.canBeClick = true;
			this.getChildGroup();
			this.getGroupPerson();
		},
		// 获取首次的组织架构
		async getFirstId() {
			let structure = (this.structure = await groupMemberApi.getStructure());
			// 首先寻找首组
			this.firstId = 0;
			this.mapStructure = {};
			let isContainFirst = false;
			for (let i = 0; i < structure.length; i++) {
				if (structure[i].parentId === 0) {
					this.firstId = structure[i].id;
					isContainFirst = true;
				}
				// 组织架构重新封装 替换为map模式 方便后面直接调用
				this.mapStructure[structure[i].id] = structure[i];
			}
			if (!isContainFirst) {
				this.firstId = this.userInfo.orgUser.groupId;
			}
		},
		ok() {
			this.$emit("ok", this.tagMap);
		},
	},
	mounted() {
		// this.getFirstId()
		this.canBeClick = true;
		this.$nextTick(() => {
			try {
				lib.setScroll($(this.$el).find(".setep2-orgnize [scroll]"));
			} catch (e) {}
		});
	},
};
</script>
<style lang="scss" scoped>
.min-h56x {
	min-height: 45rem !important;
}
.selectView {
	width: 100%;
	.border-r {
		border-right: 1px solid #dfdfdf;
	}
	.bdSub-bottom {
		bdsub-bottomottom: 1px solid #dfdfdf;
	}
	.inputwrap {
		widows: 100%;
		.inputcust {
			width: 100%;
			color: #323232;
			border: none;
			outline: none;
		}
	}
	.selectpanel {
		.romate {
			transform: rotate(180deg);
		}
		.setep1 {
		}
		.setep2-orgnize {
		}
	}
}
.searchPanel {
	.title {
		// font-size: 1.2em;
	}
	.hoverFlex {
		&:hover {
			background-color: rgba(102, 131, 153, 0.06);
		}
	}
}
.flexBox {
	display: flex;
}
.flex-r {
	flex-direction: row;
}
.flex-c {
	flex-direction: column;
}
.flex-1 {
	flex: 1;
}
.flex-just {
	justify-content: center;
}
.flex-aligh {
	align-items: center;
}
.min-h56x {
	min-height: 37em;
}
.min-h30x {
	min-height: 25em;
}
.dpB {
	display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/SelectMember.vue